import { Button, Form, Input, Select } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SUBSCRIPTION_ACTIONS } from "../../redux/subscription/action";
import ImageUploader from "../ImageUploader";

const SubscriptionForm = ({
  updateData = null,
  isUpdate = false,
  isUpdateComplete,
}) => {
  const [form] = Form.useForm();
  const [flip, setFlip] = useState(false);
  const [imageData, setImageData] = useState([]);

  const dispatch = useDispatch();

  const { formError = {} } = useSelector(
    (reducers) => reducers.subscriptionReducer,
  );

  useEffect(() => {
    if (updateData) {
      form.setFieldsValue({
        name: updateData?.name,
        description: updateData?.description,
        price: updateData?.price,
        eduthunioBlockType: updateData?.eduthunioBlockType,
      });
      setImageData(updateData?.image);
    }
  }, [updateData]);

  const onFinish = (values) => {
    dispatch({
      type: SUBSCRIPTION_ACTIONS.SET_STATE,
      payload: { formError: {} },
    });

    if (isUpdate) {
      dispatch({
        type: SUBSCRIPTION_ACTIONS.UPDATE_SUBSCRIPTION,
        payload: {
          path: { subscriptionId: updateData.id },
          body: {
            name: values.name,
            description: values.description,
            price: values.price ? Number(values.price) : undefined,
            image: imageData?.[0]?.key,
            eduthunioBlockType: values.eduthunioBlockType,
          },
        },
      });
    } else {
      dispatch({
        type: SUBSCRIPTION_ACTIONS.CREATE_SUBSCRIPTION,
        payload: {
          body: {
            name: values.name,
            description: values.description,
            price: values.price ? Number(values.price) : undefined,
            image: imageData?.[0]?.key,
            eduthunioBlockType: values.eduthunioBlockType,
          },
        },
      });
    }
  };

  return (
    <>
      <Form layout={"vertical"} form={form} onFinish={onFinish}>
        <Form.Item
          label="Name"
          name="name"
          required
          validateStatus={formError?.name?.length ? "error" : ""}
          help={formError?.name?.length ? formError.name[0] : ""}
        >
          <Input placeholder="Input name" />
        </Form.Item>

        <Form.Item
          label="Description"
          name="description"
          required
          validateStatus={formError?.description?.length ? "error" : ""}
          help={formError?.description?.length ? formError.description[0] : ""}
        >
          <Input.TextArea
            style={{ height: 120, resize: "none" }}
            placeholder="Input description"
          />
        </Form.Item>

        <Form.Item
          label="Price"
          name="price"
          required
          validateStatus={formError?.price?.length ? "error" : ""}
          help={formError?.price?.length ? formError.price[0] : ""}
        >
          <Input type="number" placeholder="Input price" />
        </Form.Item>

        <Form.Item
          label="Block Type"
          name="eduthunioBlockType"
          required
          validateStatus={formError?.eduthunioBlockType?.length ? "error" : ""}
          help={
            formError?.eduthunioBlockType?.length
              ? formError.eduthunioBlockType[0]
              : ""
          }
        >
          <Select placeholder="Select block type">
            <Select.Option value="clb">clb</Select.Option>
            <Select.Option value="slb">slb</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item
          label="Upload Avatar"
          name="imageLink"
          required
          validateStatus={formError?.image?.length ? "error" : ""}
          help={formError?.image?.length ? formError.image[0] : ""}
        >
          <ImageUploader
            fileData={imageData}
            setFileData={setImageData}
            flip={flip}
          />
        </Form.Item>

        <Form.Item>
          {isUpdate ? (
            <>
              <Button
                type="dashed"
                style={{ backgroundColor: "#f5c542" }}
                htmlType="submit"
              >
                Update
              </Button>
            </>
          ) : (
            <>
              <Button type="primary" htmlType="submit">
                Add
              </Button>
            </>
          )}
        </Form.Item>
      </Form>
    </>
  );
};

export default SubscriptionForm;
